import { useState } from "react";
import { format, parseISO } from "date-fns";
import { CalendarDays } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Calendar } from "@/components/ui/calendar";

export function DatePicker({ value, onChange, testId }) {
  const [open, setOpen] = useState(false);
  const selected = value ? parseISO(value) : undefined;
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" data-testid={testId}
          className="w-full inline-flex items-center justify-between gap-2 bg-[#FF4D00] text-white px-4 py-3 text-sm font-medium hover:bg-[#E64500] transition-colors focus:outline-none focus:ring-2 focus:ring-[#FF4D00] focus:ring-offset-2 focus:ring-offset-[#111111]">
          <span data-testid={`${testId}-value`}>{selected ? format(selected, "MMM d, yyyy") : "Pick a due date"}</span>
          <CalendarDays className="w-4 h-4" />
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" className="z-[60] w-auto p-0 rounded-none border-[#2A2A2A] bg-[#111111] text-white" data-testid={`${testId}-calendar`}>
        <Calendar mode="single" selected={selected} defaultMonth={selected}
          onSelect={(d) => { if (d) { onChange(format(d, "yyyy-MM-dd")); setOpen(false); } }}
          classNames={{
            day_selected: "bg-[#FF4D00] text-white hover:bg-[#E64500] hover:text-white focus:bg-[#FF4D00] focus:text-white",
            day_today: "border border-[#FF4D00] text-white",
          }} />
      </PopoverContent>
    </Popover>
  );
}
